import { render } from "./FormSalesman.vue?vue&type=template&id=0e0989d5"
import script from "./FormSalesman.vue?vue&type=script&lang=js"
export * from "./FormSalesman.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__